import React, { Fragment } from "react";
import _ from "lodash";
import {compose} from 'redux';
import { connect } from "react-redux";
import IconButton from "@material-ui/core/IconButton";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";
import {Dialog, DialogTitle, Grid, FormHelperText} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import {AutoCompleteInput} from 'components/Global/FastFormikMaterial';
import Dropdown from 'components/Global/Dropdown/Dropdown';
import PrimaryButton from 'components/Global/Buttons/PrimaryButton';
import SecondaryButton from 'components/Global/Buttons/SecondaryButton';
import {getCompaniesByTypeId} from 'store/state/companies';
import {getContactsByCompany} from 'store/state/contacts';
import ContactInfo from './ContactInfo';
const FormGrid = styled.div`
  padding:0 20px 20px 20px;
`
const ButtonWrapperGrid = styled(Grid)`
  margin-top:16px;
`
const FullHeight = styled.div`
  min-height:400px;
`
const StyledDropdown = styled(Dropdown)`
  margin-top:16px;
`
const Spacer = styled.div`
  flex-grow:1;
`
const Error = styled.div`
  color:red;
  align-self:center;
`
const styles = theme => ({
  dialogPaper: {
    'max-width':'500px',
    'font-size': '13px',        
  },
  dialogTitle: {    
    padding: '8px 0 0 20px'
  }
})

const ErrorMessage = ({message}) => (
  <Error>{message}</Error>
)

class ContactInformationModalForm extends React.Component {
  state ={
    hasErrors:false,
    errorMessage: ''
  }
  onCancel = () => {
    this.props.onClose();
  }
  closeModal = () => {
    this.props.onClose();  
  };    

  checkErrors = () => {
    let hasErrors = false;
    const {selectedCompanyTypeId, selectedCompanyId, selectedContactId} = this.props;
    if(!selectedCompanyTypeId){
      hasErrors = true;
      this.setState({
        hasErrors,
        errorMessage: 'Must select company type.'
      })
    }
    else if(!selectedCompanyId){
      hasErrors = true;
      this.setState({
        hasErrors,
        errorMessage: 'Must select company.'
      })
    }
    else if(!selectedContactId){
      hasErrors = true;
      this.setState({
        hasErrors,
        errorMessage: 'Must select contact name.'
      })
    }
    else if(this.isContactAlreadyInList(selectedContactId)){
      hasErrors = true;
      this.setState({
        hasErrors,
        errorMessage: 'This contact already exists on the loan'
      })
    }
    return hasErrors;
  }
  isContactAlreadyInList = (contactId) => {    
    return _.find(this.props.loanContacts, {'id': contactId}) !== undefined;
  }
  save = () => {    
    const{ selectedContactId,selectedCompanyTypeId,contactsByCompany,selectedCompanyId, companyTypes} = this.props;
    let hasErrors = this.checkErrors();
    if(hasErrors)
      return;    
    else {
      this.setState({
        hasErrors:false,
        errorMessage: ''
      })
    }
    let contactType = _.find(companyTypes, {'value':selectedCompanyTypeId});
    let contacts = _.get(contactsByCompany, selectedCompanyId, []);
    let selectedContact = _.find(contacts, {'id': selectedContactId}, null);

    let bridgeEntity = {
      contact: selectedContact,
      contactType: {
        id: contactType.value,
        name: contactType.label
      }
    };    
    this.props.onSave(bridgeEntity);
    this.closeModal();    
  }

  onCompanyTypeChange = (option) => {
    this.props.onCompanyTypeChange(option.value);
    this.props.getCompaniesByTypeId({subKey: 'loanDetailsCompanyTypes',companyTypeId: option.value});
  }
  onCompanyChange = (option) => {
    this.props.onCompanyChange(option.value);
    this.props.getContactsByCompany({companyId: option.value});
  }
  onContactChange = (option) => {
    this.props.onContactChange(option.value);
  }
  shouldRenderContactInfo = (contactOptions,selectedContact) => {    
    return contactOptions.length > 0 && selectedContact;
  }
  shouldRenderContactList = (contactOptions) => {
    return contactOptions.length > 0 && this.props.selectedCompanyId;
  }
  shouldRenderCompanyDropdown = (companyOptions) => {
    return !this.areCompanyOptionsEmpty(companyOptions) && this.props.selectedCompanyTypeId;
  }
  areCompanyOptionsEmpty = (companyOptions) => {    
    return companyOptions.length === 0;
  }
  areContactsEmpty = (contacts) => {    
    return contacts.length === 0 && this.props.selectedCompanyId;
  }
  render() {
    let {selectedCompanyTypeId, selectedContactId, contactsByCompany,
         selectedCompanyId, isOpen, classes, companiesByTypeId} = this.props;
    // remove Sponsor from the company type list per business requirements (request from Caleb)
    const uniqueCompanyTypes = _.uniqBy(this.props.companyTypes, 'label');
    const companyTypes = uniqueCompanyTypes.filter(company => company.label !== 'Sponsor');
   
    const {hasErrors, errorMessage} = this.state;    
    let companiesByType = _.get(companiesByTypeId, 'loanDetailsCompanyTypes', [])    
    let companyOptions = companiesByType.map(x => ({ label: x.name, value: x.id}));
    const sortedCompanyOptions = companyOptions.sort((a,b) => {
      if (a.label < b.label) {return -1}
      if (a.label > b.label) {return 1}
      return 0;
    });
    let contacts = _.get(contactsByCompany, selectedCompanyId, []);
    let contactOptions = contacts.map(x => ({label: _.get(x, 'firstName', '')+ ' ' + _.get(x, 'lastName',''), value: x.id}));
    let selectedContact = _.find(contacts, {'id': selectedContactId}, null);
    return (
      <Fragment>        
        <Dialog open={isOpen} onClose={this.closeModal} fullWidth maxWidth="md" classes={{paper: classes.dialogPaper}}>
          <Grid
            container
            direction="row"
            alignItems="center"
            justify="space-between">
            <DialogTitle classes={{root: classes.dialogTitle}}>Contact</DialogTitle>
            <IconButton style={{ marginRight: 8,marginTop:8 }} onClick={this.closeModal}>
              <CloseIcon style={{ fontSize: 36 }} />
            </IconButton>
          </Grid>
          <FormGrid>
          <FullHeight>
            <p>
              If you do not see the company or user you are looking for, please contact your LoanBoss Administrator.
            </p>
            <StyledDropdown         
              placeholder="Type"    
              id="dropdownForContactModelContactType"                
              onChange={this.onCompanyTypeChange}
              selectedValue={selectedCompanyTypeId}
              options={companyTypes}
            />
            {this.shouldRenderCompanyDropdown(companyOptions) && 
              <StyledDropdown      
                id="dropdownForContactModelCompany"            
                placeholder="Company"
                onChange={this.onCompanyChange}
                selectedValue={selectedCompanyId}
                options={sortedCompanyOptions}
              />
            }
            {this.shouldRenderContactList(contactOptions) &&
              <StyledDropdown
                placeholder="Name"
                id="dropdownForContactModelName"   
                onChange={this.onContactChange}
                selectedValue={selectedContactId}              
                options={contactOptions}/>
            }
            {
              this.areContactsEmpty(contactOptions) && <div>There are no contacts in this company. Please contact your LoanBoss Administrator to add someone.</div>
            }
            {this.shouldRenderContactInfo(contactOptions, selectedContact) &&
              <ContactInfo contact={selectedContact}/>
            }
          </FullHeight>
          <ButtonWrapperGrid container direction="row" justify="flex-end">
            {hasErrors && <ErrorMessage message={errorMessage}/>}
            <Spacer/>
            <SecondaryButton id="contactModelCancelButton" onClick={this.onCancel}>Cancel</SecondaryButton>
            <PrimaryButton id="contactModelAddButton" onClick={() => this.save()}>Add</PrimaryButton>
          </ButtonWrapperGrid>
          </FormGrid>
        </Dialog>
      </Fragment>
    );
  }
}

function mapStateToProps({companies,contacts}) {
  return {
    companiesByTypeId: companies.companiesByTypeId,
    contactsByCompany: contacts.contactsByCompany
  };
}


export default compose(
  connect(
    mapStateToProps,
    {
      getCompaniesByTypeId,
      getContactsByCompany
    }
  ),
  withStyles(styles)
)(ContactInformationModalForm);